import { getAppByIdAndVersion } from '@/redux/actions/gravityActions.js';
import { findStepApp } from '@shared/workflow/findStepApp.js';
import { updateWorkflowStep } from '@shared/workflow/updateWorkflowStep.js';

const cookUpdatedWorkflowStep = async (store, newStep, opts = {}) => {
  const apps = store?.workflow?.appsVersions;
  const appsMetadata = store?.workflow?.appsMetadata;
  // Step edits always target the draft. The store can hold several copies of the same
  // workflow id (draft + published/semver, e.g. after landing on a /published route), and
  // cooking against a published copy strips draft-only data — cleanUpWorkflowStep filters a
  // map step's inputStepIds against workflow.steps, so a step that only exists in the draft
  // would be silently dropped from the cooked result and synced away.
  const workflow = store?.workflow?.workflows?.find((n) => n?.id === newStep?.workflowId && n?.version === 'draft');

  if (!workflow) {
    console.error('Error updating step, cannot find draft workflow.', newStep?.workflowId);
    return {
      success: false,
      data: [],
      meta: {
        changes: []
      }
    };
  }

  const step = workflow?.steps?.find((n) => n.id === newStep?.id);
  const appId = newStep?.appId || step?.appId;
  const credential = store?.workflow?.credentials?.find((n) => n.credentialId === (newStep?.credentialId || step?.credentialId));
  const appVersion = newStep?.appVersion ?? step?.appVersion ?? '0';
  const isFunction = !!newStep?.functionId;

  let app = findStepApp({ appId, appVersion }, apps);
  if (!app) {
    app = (await getAppByIdAndVersion({ appId, appVersion }))?.[0];
  }

  if (!app && !isFunction) {
    console.error('Error updating step, cannot find app.');
    return {
      success: false,
      data: [],
      meta: {
        changes: []
      }
    };
  }

  const updatedStep = await updateWorkflowStep({
    id: newStep?.id,
    data: {
      ...newStep,
      appId,
      appVersion: newStep?.appVersion || step?.appVersion,
      workflowId: newStep?.workflowId,
      functionId: newStep?.functionId,
      updatedBy: store?.user?.jwt?.id
    },
    userId: store?.user?.jwt?.id,
    apps,
    appsMetadata,
    workflow,
    companyId: store?.user?.companyId,
    credential,
    opts
  });
  return { success: true, data: updatedStep };
};

export default cookUpdatedWorkflowStep;
